import React from 'react';
import { useFilterForm } from 'hooks/searchParams/useFilterForm/useFilterForm';
import { DateRangeFilter } from '../DateRangeFilter/DateRangeFilter';
import Filterbar from 'components/molecule/Filterbar/Filterbar';
import Button from 'components/atoms/button/Button';
import FilterBadgeList from 'components/organism/FilterBadgeList/FilterBadgeList';
import { FilterFormCtx } from '../filterFormCtx';

export function FilterBarForm({ FilterForm, HeaderForm, showDateInputs = true, isLoading, fields, children }) {
  const formProps = useFilterForm({ fields });
  const { onSubmit, onReset, register, control, values, filterFields } = formProps;
  const formFields = fields || filterFields;

  return (
    <FilterFormCtx.Provider value={formProps}>
      {FilterForm && (
        <div className='flex gap-2 sm:gap-3 flex-wrap items-center'>
          <Filterbar
            onSubmit={onSubmit}
            onCancel={onReset}
            onlyModal
            isLoading={isLoading}>
            <FilterForm
              register={register}
              control={control}
            />
          </Filterbar>
          {children}
        </div>
      )}

      {showDateInputs && (
        <>
          <div className='flex w-full flex-col gap-3 lg:w-max lg:flex-row [&>*]:w-full lg:[&>*]:w-auto [&>div>div>button]:w-full'>
            {HeaderForm && (
              <HeaderForm
                register={register}
                control={control}
              />
            )}
            <DateRangeFilter />
          </div>

          <Button
            title='Apply'
            type='submit'
            disabled={isLoading}
            className='hidden lg:flex'
            onClickHandler={onSubmit}
          />
        </>
      )}

      <FilterBadgeList
        filters={values}
        onClear={onReset}
        onClearAll={onReset}
        fields={formFields}
      />
    </FilterFormCtx.Provider>
  );
}
